var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdherents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.29 35.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.75,35.3c-.12,0-.25-.04-.35-.12l-3.07-2.48-3.07,2.48c-.2,.17-.49,.17-.69,0l-3.07-2.48-3.07,2.48c-.2,.17-.49,.17-.69,0l-3.07-2.48-3.07,2.48c-.2,.17-.49,.17-.69,0l-3.07-2.48-3.07,2.48c-.2,.17-.49,.17-.69,0l-3.07-2.48-3.07,2.48c-.17,.13-.4,.16-.59,.07-.19-.09-.31-.29-.31-.5V2.76C0,1.24,1.24,0,2.76,0h29.78c1.52,0,2.75,1.24,2.75,2.76v31.98c0,.21-.12,.41-.31,.5-.08,.03-.15,.06-.24,.06Zm-17.1-3.86c.12,0,.24,.04,.34,.12l3.07,2.48,3.07-2.48c.2-.16,.49-.16,.69,0l3.07,2.48,3.07-2.48c.2-.16,.49-.16,.69,0l2.52,2.03V2.76c0-.91-.74-1.65-1.65-1.65H2.76c-.91,0-1.65,.74-1.65,1.65v30.83l2.52-2.03c.2-.16,.49-.16,.69,0l3.07,2.48,3.07-2.48c.2-.16,.49-.16,.69,0l3.07,2.48,3.07-2.48c.1-.08,.22-.12,.34-.12Z",
    style: {
      fill: "#5f8a8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.23,18.2h-4.41c-.31,0-.55-.25-.55-.55s.24-.55,.55-.55h4.41c.31,0,.55,.24,.55,.55s-.25,.55-.55,.55Z",
    style: {
      fill: "#5f8a8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.23,13.79h-4.41c-.31,0-.55-.25-.55-.55s.24-.55,.55-.55h4.41c.31,0,.55,.24,.55,.55s-.25,.55-.55,.55Z",
    style: {
      fill: "#d29b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.23,9.38h-4.41c-.31,0-.55-.24-.55-.55s.24-.55,.55-.55h4.41c.31,0,.55,.25,.55,.55s-.25,.55-.55,.55Z",
    style: {
      fill: "#d29b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.23,26.2H6.07c-.46,0-.83-.37-.83-.83s.37-.83,.83-.83H29.23c.45,0,.83,.37,.83,.83s-.37,.83-.83,.83Z",
    style: {
      fill: "#5f8a8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M21.42,19.72c-.24,0-.48-.16-.48-.48,0,0-.16-2.07-1.59-2.87l-3.02-1.27c-1.51,.56-3.1,.56-4.62,0l-3.02,1.27c-1.43,.72-1.59,2.79-1.59,2.87,0,.24-.24,.48-.48,.48s-.48-.24-.48-.48c0-.08,.16-2.63,2.07-3.66h0l3.26-1.35c.16-.08,.24-.08,.4,0,1.35,.56,2.87,.56,4.22,0,.16-.08,.24-.08,.4,0l3.26,1.35h0c1.99,.96,2.07,3.5,2.07,3.66,.08,.24-.08,.48-.4,.48q.08,0,0,0h0Z",
    style: {
      fill: "#d29b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M15.45,13.27c-.24,0-.48-.24-.48-.48,0-.16,.08-.32,.24-.4,1.11-.72,1.19-1.11,1.27-2.31v-.24c.16-.64,.08-1.27-.16-1.91-.32-.48-.72-.88-1.27-1.03-.64-.24-1.35-.24-1.99,0-.56,.16-1.03,.56-1.27,1.03-.24,.64-.32,1.27-.16,1.91v.24c.16,1.11,.16,1.51,1.27,2.31,.24,.16,.24,.4,.16,.64s-.4,.24-.64,.16h0c-1.11-.56-1.75-1.75-1.67-2.94v-.24c-.16-.8-.08-1.67,.32-2.47,.4-.72,1.03-1.27,1.83-1.51,.8-.24,1.75-.24,2.55,0s1.43,.8,1.83,1.51c.32,.8,.48,1.59,.32,2.47v.24c0,1.19-.64,2.39-1.67,2.94-.32,0-.4,.08-.48,.08Z",
    style: {
      fill: "#d29b4d"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdherents);
export default __webpack_public_path__ + "static/media/adherents.2e3bd50db6a7cc3e1a5da7cb712db0a1.svg";
export { ForwardRef as ReactComponent };